import React from "react"
import { ButtonContainer, Button, Helpers } from "./styles"
import { P } from "../typography"

const NpsScale = ({ onClick, selected }) => {
  const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  const handleClick = (num) => {
    onClick(num)
  }

  return (
    <div>
      <ButtonContainer>
        {numbers.map((num) => (
          <Button
            key={num}
            num={num}
            onClick={() => handleClick(num)}
            type="button"
            length={numbers.length}
            selected={selected === num}
          >
            {num}
          </Button>
        ))}
      </ButtonContainer>
      <Helpers>
        <P variant="content" size="small">
          Not great
        </P>
        <P variant="content" size="small">
          Great
        </P>
      </Helpers>
    </div>
  )
}

export default NpsScale
